import { Component } from '@angular/core';
import { UilabMatButton } from '@uilab/ng-mat-components';
import { CodeExampleComponent } from 'src/app/shared/components/code-example/code-example.component';
import { CodeExampleHeaderComponent } from 'src/app/shared/components/code-example/code-example-header.component';
import { COMPONENT_EXAMPLES_CONSTANTS } from '../component-examples.constants';

interface ButtonExample {
    readonly variant: 'filled' | 'outlined' | 'text';
    readonly label: string;
    readonly description: string;
    readonly htmlSnippet: string;
    readonly previewText: string;
    readonly icon: string;
    readonly kind: 'button';
    readonly buttonAppearance: '' | 'filled' | 'outlined' | 'text';
}

@Component({
    selector: 'avd-button-examples',
    templateUrl: './button-examples.component.html',
    styleUrls: ['./button-examples.component.scss'],
    imports: [CodeExampleHeaderComponent, CodeExampleComponent, UilabMatButton],
})
export class ButtonExamplesComponent {
    readonly packageName = COMPONENT_EXAMPLES_CONSTANTS.PACKAGE_NAME;
    readonly getStartedLink = COMPONENT_EXAMPLES_CONSTANTS.GET_STARTED_LINK;
    readonly storybookLink = `${COMPONENT_EXAMPLES_CONSTANTS.STORYBOOK_BASE_URL}/?path=/docs/components-buttons-button--docs`;
    readonly repoLink = `${COMPONENT_EXAMPLES_CONSTANTS.AZURE_DEVOPS_BASE_URL}&path=/projects/components/src/lib/buttons`;

    readonly examples: readonly ButtonExample[] = [
        {
            variant: 'filled',
            label: 'Filled Button',
            description:
                'Use the filled appearance for the primary action on a page.',
            htmlSnippet: `<button uilabMatButton="filled">Button</button>`,
            previewText: 'Button',
            icon: '',
            kind: 'button',
            buttonAppearance: 'filled',
        },
        {
            variant: 'outlined',
            label: 'Outlined Button',
            description:
                'Use the outlined appearance for secondary actions alongside a filled button.',
            htmlSnippet: `<button uilabMatButton="outlined">Button</button>`,
            previewText: 'Button',
            icon: '',
            kind: 'button',
            buttonAppearance: 'outlined',
        },
        {
            variant: 'text',
            label: 'Text Button',
            description:
                'Use the text appearance for low-emphasis actions in toolbars, dialogs, and inline flows.',
            htmlSnippet: `<button uilabMatButton="text">Button</button>`,
            previewText: 'Button',
            icon: '',
            kind: 'button',
            buttonAppearance: 'text',
        },
    ];
}
